//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsApi,getLineItemsApi,createLineItemApi,updateLineItemApi,
    moveDownLineItemApi,moveUpLineItemApi,deleteLineItemApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type } from '../genericFlowTypes'
import type { EditFormData,PostPayloadData  } from '../phobos/flowTypes'

const workflowType = 'Harmonia'

export const getTaskData=(harmonia:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.HARMONIA_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,harmonia)
            dispatch({
                type: actionTypes.HARMONIA_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.HARMONIA_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.HARMONIA_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,harmoniaResultset:any,harmonia:ReducerState$Type)=>{
    let payload:PostPayloadData={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (harmoniaResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=harmoniaResultset.vendorName;
        payload.invNo=harmoniaResultset.invNo;
        payload.invDate=harmoniaResultset.invDate;
        payload.serviceAddr=harmoniaResultset.serviceAddr;
        payload.total=harmoniaResultset.total;
        payload.isInvalidDoc=harmoniaResultset.isInvalidDoc?harmoniaResultset.isInvalidDoc:false;
        payload.isOverrideTotal=harmoniaResultset.isOverrideTotal?harmoniaResultset.isOverrideTotal:false;
        payload.isOverrideVendorName=harmoniaResultset.isOverrideVendorName?harmoniaResultset.isOverrideVendorName:false;
    }

    if (harmonia.reviewQuestions && harmonia.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(harmoniaResultset,harmonia.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.HARMONIA_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.HARMONIA_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.HARMONIA_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.HARMONIA_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsApi(jwt,workflowType).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_HARMONIA_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_HARMONIA_VENDORS_SUCCESS, vendors: data.vendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_HARMONIA_VENDORS_ERROR, error: err});
    })
}

export const getLineItems=(jwt:any,page:number,pageSize:number,sortField:string,sortOrder:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch$Type) => getLineItemsApi(jwt,workflowType,page,pageSize,sortField,sortOrder,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GET_HARMONIA_ITEMS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GET_HARMONIA_ITEMS_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GET_HARMONIA_ITEMS_ERROR,error: err});
    })
}

export const setPage=(jwt:any,harmonia:ReducerState$Type,page:number)=>{
    return getLineItems(jwt,page,(harmonia.pageSize:any),(harmonia.sortField:any),harmonia.sortOrder,(harmonia.taskAcceptedInfoId:any));
}

export const setPageSize=(jwt:any,harmonia:ReducerState$Type,pageSize:number)=>{
    return getLineItems(jwt,(harmonia.page:any),pageSize,(harmonia.sortField:any),harmonia.sortOrder,(harmonia.taskAcceptedInfoId:any));
}

export const sortData=(jwt:any,harmonia:ReducerState$Type,sortField:any,sortOrder:any)=>{
    return getLineItems(jwt,(harmonia.page:any),(harmonia.pageSize:any),sortField,sortOrder,(harmonia.taskAcceptedInfoId:any));
}

export const createNewLineItem=(jwt:any,newLineItem:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch$Type) => createLineItemApi(jwt,workflowType,newLineItem,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.CREATE_NEW_HARMONIA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.CREATE_NEW_HARMONIA_ITEM_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.CREATE_NEW_HARMONIA_ITEM_ERROR,error: err});
    })
}

export const editLineItem=(lineItem:any)=>{
    let convertToFormObj={};
    convertToFormObj.id=lineItem.id;
    convertToFormObj.itemDesc=lineItem.item_desc;
    convertToFormObj.itemAmount=lineItem.item_amount;
    
    return { type: actionTypes.EDIT_HARMONIA_ITEM, lineItem: convertToFormObj };
}

export const updateLineItem=(jwt:any,updateLineItem:any,id:number)=>{
    return (dispatch:Dispatch$Type) => updateLineItemApi(jwt,workflowType,updateLineItem,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_HARMONIA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.UPDATE_HARMONIA_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_HARMONIA_ITEM_ERROR,error: err});
    })
}

export const moveDownLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => moveDownLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_DOWN_HARMONIA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_DOWN_HARMONIA_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_DOWN_HARMONIA_ITEM_ERROR,error: err});
    })
}

export const moveUpLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => moveUpLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_UP_HARMONIA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_UP_HARMONIA_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_UP_HARMONIA_ITEM_ERROR,error: err});
    })
}

export const deleteLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => deleteLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.DELETE_HARMONIA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.DELETE_HARMONIA_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DELETE_HARMONIA_ITEM_ERROR,error: err});
    })
}

export const openAddEditLineItemForm=()=>{
    return { type: actionTypes.OPEN_ADD_EDIT_LINEITEM_FORM };
}

export const lineItemSelectedId=(id:number)=>{
    return { type: actionTypes.SELECTED_HARMONIA_ITEM_ID, lineItemId: id}
}

export const cancelAddEditLineItemForm=()=>{
    return { type: actionTypes.CANCEL_ADD_EDIT_LINEITEN_FORM };
}


// WEBPACK FOOTER //
// ./src/redux/harmonia/actions.js